module.exports = __webpack_public_path__ + "media/images/lb/031-8e0a6a2252192e726c523969a76a7096.svg";